import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/phrases",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  console.log("[AdminPhrase] Bearer token present:", !!token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("[AdminPhrase] No token found, request may fail with 401");
  }
  return config;
});

const handle = (label, promise) =>
  promise
    .then((res) => {
      console.log(`[AdminPhrase] ${label} response:`, res.status, res.data);
      return { status: res.status, data: res.data };
    })
    .catch((err) => {
      console.error(`[AdminPhrase] ${label} failed:`, err.response?.status, err.response?.data);
      return {
        status: err.response?.status || 500,
        message: err.response?.data?.message || "Request failed",
      };
    });

export const fetchPhrases = (params) => {
  console.log("[AdminPhrase] Fetching all phrases, params:", params);
  return handle("Fetch phrases", api.get("", { params }));
};
export const fetchPhraseById = (id) => {
  console.log("[AdminPhrase] Fetching phrase by id:", id);
  return handle("Fetch phrase by id", api.get(`/${id}`));
};
export const createPhrase = (data) => {
  console.log("[AdminPhrase] Creating phrase:", data);
  return handle("Create phrase", api.post("", data));
};
export const updatePhrase = (id, data) => {
  console.log("[AdminPhrase] Updating phrase id:", id, "data:", data);
  return handle("Update phrase", api.put(`/${id}`, data));
};
export const deletePhrase = (id) => {
  console.log("[AdminPhrase] Deleting phrase id:", id);
  return handle("Delete phrase", api.delete(`/${id}`));
};
